module.exports = __webpack_public_path__ + "img/swap.f7b2a8c3.svg";